import type { Dictionnaire } from '../type';

export const temps: Dictionnaire['temps'] = {
  ilYa: {
    instant: '刚刚',
    minutes: (n: number) => `${n} 分钟前`,
    heures: (n: number) => `${n} 小时前`,
    jours: (n: number) => `${n} 天前`,
    semaines: (n: number) => `${n} 周前`,
    mois: (n: number) => `${n} 个月前`,
    ans: (n: number) => `${n} 年前`,
  },
  hier: '昨天',
  Hier: '昨天',
  aujourdhui: '今天',
  heure: {
    pleine: (h: number) => `${String(h).padStart(2, '0')}:00`,
    avecMinutes: (h: number, minutes: string) => `${String(h).padStart(2, '0')}:${minutes}`,
  },
  masqueDate: 'DD / MM / YYYY',
  aujourdhuiMin: '今天',
};
